import React from "react"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"
import SubBanner from "./SubBanner/SubBanner"

const StyledHero = ({ img, className, children, home }) => {
  return (
    <>
      <BackgroundImage className={className} fluid={img} home={home}>
        {children}
      </BackgroundImage>
      <SubBanner />
    </>
  )
}

export default styled(StyledHero)`
  min-height: ${props => (props.home ? "calc(75vh - 66px)" : "55vh")};
  background: ${props =>
    props.opacity
      ? "linear-gradient(rgb(26, 188, 156), rgba(0, 0, 0, 0.01))"
      : "none"};
  background-position: center;
  background-size: cover;
  opacity: 1 !important;
  display: flex;
  justify-content: center;
  align-items: center;
`
